module.exports = __webpack_public_path__ + "img/whatsapp-icon.4378eed0.svg";